<template>
  <div style="height: 100%;">
    <div data-v-37dfd6fc="" class="login-container login-turing-container" style="height: 100%;">
      <div style="cursor: pointer;" @click="toPath">
        <img src="@/assets/img/logo.svg" alt="logo"/>
      </div>
      <div data-v-37dfd6fc="" class="index-login-section" style="position: relative;left: 35%;
    top: 50%;
    transform: translate(-50%, -50%);" v-if="smsCodeState">
        <el-form label-position="rigth" :model="ruleForm" ref="ruleForm" data-v-37dfd6fc=""
          class="el-form login-form el-form--label-left" autocomplete="on">
          <div data-v-37dfd6fc="" class="img-logo" style="font-size: 22px;color: rgb(232, 127, 41);display: flex;">
            <div class="yzmBox" @click="switchLoginTab('sms')">
              <span class="sjh" style="cursor: pointer;" :style="{ color: loginTab === 'sms' ? 'orange' : 'black' }">快捷登录</span>
              <div class="activeBorder" :style="{ opacity: loginTab === 'sms' ? 1 : 0 }"></div>
            </div>
            <div class="yzmBox" @click="switchLoginTab('password')">
              <span class="sjh" style="cursor: pointer;" :style="{ color: loginTab === 'password' ? 'orange' : 'black' }">密码登录</span>
              <div class="activeBorder" :style="{ opacity: loginTab === 'password' ? 1 : 0 }"></div>
            </div>
          </div>

          <!-- 短信登录表单 -->
          <div v-show="loginTab === 'sms'">
            <el-form-item prop="userPhone" class="username">
              <el-input name="userPhone" class="el-input-iphone" type="text" maxlength="11"
                v-model.trim="ruleForm.userPhone" auto-complete="off" style="color: #000000;background-color: #fff;"
                placeholder="手机号">
                <template #prefix>
                  <img src="@/assets/icons/svg/phone2.svg" alt="phone" style="width: 14px; height: 14px;    position: relative;left: 2px;  top: 2px;" />
                </template>
              </el-input>
            </el-form-item>
            <el-row style="margin-top: 0px;">
              <el-form-item prop="smsCode" style="margin-top: 0px;">
                <el-input class="el-input-yzm" type="text" v-model="ruleForm.smsCode" auto-complete="off"
                  style="color: #000000;background-color: #fff;" placeholder="短信验证码">
                  <template #prefix>
                    <img src="@/assets/icons/svg/secure.svg" alt="secure" style="width: 20px; height:20px;" />
                  </template>
                  <template #append>
                    <el-button @click="sendSms" :disabled="countdown > 0" type="text" :style="{ color: countdown > 0 ? '#999999' : '#1976d2', minWidth: '90px' }">{{ countdown > 0 ? `重新发送（${countdown}）` : '获取验证码' }}</el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-row>
            <el-form-item prop="companyId" class="username" v-if="ruleForm.companyId != ''">
              <el-input v-model="ruleForm.companyName" auto-complete="off" maxlength="30" type="text"
                disabled></el-input>
            </el-form-item>
            <p style="position: relative;color: rgb(155, 155, 155);font-size: 14px;top: -15px;left: 68px;">
              首次登录的用户系统将会为你自动创建账号
            </p>
            <div class="third-party-login" style="margin: 20px 0;">
              <div class="divider">
                <span>其他登录方式</span>
              </div>
              <div class="third-party-icons">
                <div class="icon-item" @click="handleThirdPartyLogin('wechat_open')">
                  <img src="@/assets/img/wx.png" alt="微信"  width="30" />
                </div>
              </div>
            </div>
            <el-button type="primary" class="login-bottom-submit" :loading="logining" @click="submitForm('ruleForm')"
              style="background: #e55c00;border: none;box-shadow: 0px 2px 8px 0px rgba(229, 92, 0, 0.5);margin-top: 20px;"
              id="submitbtn">登录</el-button>
            <p style="color: rgb(155, 155, 155);font-size: 14px;text-align: center;">
              <el-checkbox v-model="checked">我已查看并阅读<a style="color: #e55c00;" @click="showPrivacyDialog">《用户隐私协议》</a></el-checkbox>
            </p>
          </div>

          <!-- 密码登录表单 -->
          <div v-show="loginTab === 'password'">
            <el-form-item prop="userPhone" class="username">
              <el-input name="userPhone" class="el-input-iphone" type="text" maxlength="11"
                v-model.trim="ruleForm.userPhone" auto-complete="off" style="color: #000000;background-color: #fff;"
                placeholder="请输入手机号">
                <template #prefix>
                                  <img src="@/assets/icons/svg/phone2.svg" alt="phone" style="width: 14px; height: 14px;    position: relative;left: 2px;  top: 2px;" />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="userPassword">
              <el-input name="userPassword" class="el-input-iphone" :type="passwordVisible ? 'text' : 'password'" maxlength="20"
                v-model.trim="ruleForm.userPassword" auto-complete="off" style="color: #000000;background-color: #fff;"
                placeholder="请输入8-20位密码">
                <template #prefix>
                  <img src="@/assets/icons/svg/password2.svg" alt="password" style="width: 20px; height: 20px;" />
                </template>
                <template #suffix>
                  <i :class="['el-icon-view', { 'is-active': passwordVisible }]" @click="passwordVisible = !passwordVisible" style="cursor: pointer;"></i>
                </template>
              </el-input>
            </el-form-item>
            <div v-if="formError" class="form-error-message">
              <i class="el-icon-warning"></i>
              <span>{{ formError }}</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin: -10px 0 10px 0; font-size: 16px; padding: 0 68px; font-size: 12px; line-height: 30px;">
              <div>
                还没账户？<a style="color: #1976d2; cursor: pointer;" @click="$router.push('/register')">免费注册</a>
              </div>
              <div>
                <a style="color: #1976d2; cursor: pointer;" @click="$router.push('/forgot-password')">忘记密码</a>
              </div>
            </div>
            <div class="third-party-login" style="margin: 20px 0;">
              <div class="divider">
                <span>其他登录方式</span>
              </div>
              <div class="third-party-icons">
                <div class="icon-item" @click="handleThirdPartyLogin('wechat_open')">
                  <img src="@/assets/img/wx.png" alt="微信" width="30" />
                </div>
              </div>
            </div>
            <el-button type="primary" class="login-bottom-submit" :loading="logining" @click="submitPasswordLogin"
              style="background: #e55c00;border: none;box-shadow: 0px 2px 8px 0px rgba(229, 92, 0, 0.5);margin-top: 20px;"
              id="submitbtn">登录</el-button>
            <p style="color: rgb(155, 155, 155);font-size: 14px;text-align: center;">
              <el-checkbox v-model="checked">我已查看并阅读<a style="color: #e55c00;" @click="showPrivacyDialog">《用户隐私协议》</a></el-checkbox>
            </p>
          </div>

          <div v-show="!toggleState" class="qrbox">
            <div>请使用微信扫描下方二维码</div>
            <div id="login_container" class="qr-code" style="height: 308px"></div>
            <div style="font-size:14px">
              扫码确认已阅读并同意
              <span style="color:  rgb(229, 92, 0);">用户服务协议</span>和
              <span style="color:  rgb(229, 92, 0);">隐私表现</span>
            </div>
          </div>
        </el-form>
      </div>
      <div data-v-37dfd6fc="" class="index-footer">
        <div data-v-37dfd6fc="" class="index-footer-wrap">
          <div data-v-37dfd6fc="" class="index-footer-wrapbottom">
            <br data-v-37dfd6fc="" />
            Copyright©2024 中人工业互联网（苏州）有限公司
          </div>
        </div>
      </div>
    </div>

    <!-- 隐私政策对话框 -->
    <el-dialog
      title="用户隐私协议"
      :visible.sync="privacyDialogVisible"
      width="60%"
      top="10vh"
      class="privacy-dialog">
      <div class="privacy-content">
        <p class="MsoNormal">
          中人工业互联网平台（以下统称"本产品"）是由中人工业互联网（苏州）有限公司 （下称"本公司"或"我们"）所有和负责运营，本协议双方为本公司与本产品注册用户（下称"用户"或"您"）签定的具有合同效力的文件。
        </p>
        <p class="MsoNormal">
          请您在注册成为本产品用户前务必仔细阅读本协议内容，若您不同意本协议的任何内容，或者无法准确理解本公司对条款的解释，请不要进行后续操作；若您注册成为本产品用户，则表示您对本协议的全部内容已充分阅读并认可和同意遵守。 同时，承诺遵守中国法律、法规、规章及其他政府规范性文件规定，如有违反而造成任何法律后果，您将以本人名义独立承担所有相应的法律责任。
        </p>
        <p class="MsoNormal">
          如您未满18周岁，请在监护人陪同下仔细阅读并充分理解本协议，并征得监护人的同意后使用本产品及相关服务。
        </p>
        <p class="MsoNormal">
          本公司有权根据需要不定时地制定、修改本协议或各类规则，经修订的协议、规则一经公布，立即自动生效。 对新协议、规则生效之后注册的用户发生法律效力，对于协议、规则生效之前注册的用户，若用户在新规则生效后继续使用本产品提供的各项服务，则表明用户已充分阅读并认可和同意遵守新的协议或规则。 若用户拒绝接受新的协议和规则，用户有权放弃或终止继续使用本产品提供的各项服务，但该用户应承担在本产品已经进行的交易下所应承担的任何法律责任，且应遵循该用户发生交易时有效的协议或规则内容。
        </p>
        <p class="MsoNormal">
          发布日期：2025年03月28日<br>
          生效日期：2025年03月28日
        </p>
        <p class="MsoNormal">
          <strong>一、定义与解释</strong><br>
          1、本平台：指中人工业互联网平台（网址： https://www.zrgyhl.com ），公司凭借对工业互联网、云计算、大数据、人工智能等前沿技术的深刻理解和广泛应用，打造全球领先的工业互联网综合服务平台。<br>
          2、用户：本协议中的"用户"指在阅读本协议后选择接受本协议全部条款的使用者及浏览访问本产品的使用者。用户可通过游客方式访问、浏览本产品的业务，也可以使用本产品的部分服务，若用户选择注册、登录本产品的，也可以在注册登陆后使用本产品的服务。<br>
          3、关联公司：指任何直接或间接控制本公司、受本公司控制或与本公司受共同控制的任何一方。此处的"控制"和"受控制"分别指通过投票权或其他方式而督导某一方的管理政策的权利。<br>
          4、账号及密码：指您完成真实信息注册后，享有的用户账号及相应的密码，该用户账号和密码由您负责保管；您应当对以其用户账号下进行的所有行为负法律责任。
        </p>
        <p class="MsoNormal">
          <strong>二、关于"账号"</strong><br>
          1、账号的注册<br>
          （1）您使用本产品可以自行申请注册账户进行授权登录，您的账号为您注册使用的手机号，通过"账号+密码+姓名"方式注册和登录。您设置的账号您用以登录并以注册用户身份使用本产品的凭证，中人建议您使用实名认证。<br>
          （2）您理解并承诺，您所设置的账号不得违反国家法律法规及本公司的相关规则，您的账号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开设账号，不得恶意注册账号（包括但不限于频繁注册、批量注册账号等行为）。您在账号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。本公司有权对您提交的注册信息进行审核。<br>
          （3）在您注册时，本产品将获取您的姓名、手机号、用户名等信息，您应保证注册/登录账号时需填写有效的手机号码，并使用手机验证短信来完成账户注册。若因您填写的手机号码不完整或不准确，则可能无法使用本产品或在使用过程中受到限制。<br>
          （4）您应保证您注册时提供的信息的真实性，请您在注册、管理账号时使用真实、准确、合法、有效的相关信息认证材料及必要信息。若您提交的材料或提供的信息不准确、不真实、不合法或者本公司有理由怀疑为错误、不实或不合法的资料，则本公司有权拒绝为您提供相关服务或您可能无法使用本产品或在使用过程中部分功能受到限制。
        </p>
        <p class="MsoNormal">
          2、账号使用<br>
          （1）企业认证：本产品提供的部分服务需要您完成企业认证后方可使用，您同意，在您进行企业认证时，您应当按照本产品的要求如实提供认证所需信息，包括但不限于企业名称、注册资本、营业执照、统一信用代码、法人姓名、注册地、授权材料等信息。完成认证后，您在本产品上进行的一切操作行为即代表所认证企业的行为。<br>
          （2）您在本产品中的注册账号所有权及有关权益均归本公司所有，您完成注册手续后仅享有该账号的使用权，您应当正确、适当地使用、运营、管理本产品账号。您的账号仅限于您本人使用，未经本公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。 如果本公司发现或者有合理理由认为账号使用者并非您本人，本公司有权在未通知您的情况下，暂停或终止向该注册账号提供服务，并有权注销该账号，而无需向您户承担法律责任。<br>
          （3）您有责任维护您的个人账号的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您通过本产品上进行的任何数据修改、言论发表等操作行为。您应高度重视对账号的保密，在任何情况下不向他人透露账号。若发现他人未经许可使用您的账号或发生其他任何安全漏洞问题时，您应当立即通知本公司。<br>
          （4）您的账号在丢失后，可遵照本公司的申诉途径及时申诉请求找回账号。您理解并认可，本公司的账号找回机制仅需要识别申诉单上所填资料与系统记录资料具有一致性，若您提供的信息不真实或不完整，导致无法核实您的身份或判断您的需求而未进行及时处理所造成的一切损失由您自行承担。同时，您理解我们的回复和采取措施需要合理期限。我们不对非本团队原因造成的任何损失承担责任。<br>
          （5）本公司特别提醒您应妥善保管您的账号，当您使用完毕后，应安全退出。因您保管不当可能导致遭受盗号，责任由您自行承担。 如您的账户遭到第三方使用或发生其他任何问题，您有义务及时通知本公司（包括但不限于提供您的身份信息和相关身份资料、相关事实情况及您的要求等）。<br>
          （6）为保障您和本公司利益，本公司有权审查您提交的相关材料（如自然人持有的身份证照片、企业法人营业执照副本复印件、事业单位法人证书复印件）并有权决定是否核准您的申请，并有权视情况要求您提供声明/说明、服务资质、服务范围及其他等材料。若您拒绝提供材料或提交的材料或填写的信息不真实、不准确、不完整或不合法的，则您可能无法使用本产品或在使用过程中受到限制。 本公司的审查不代表对您提交的材料和信息的真实性、准确性、真实性、合法性负责。您应当对该材料和信息独立承担责任。<br>
          （7）为更好的为您提供服务，本公司有权对使用本产品的用户进行分级、分类管理，并有权根据级别设置相应的权限、提供相应的服务。
        </p>
        <p class="MsoNormal">
          3、账号的注销<br>
          用户可以自行在web端操作注销账号。<br>
          您也可以按照以下步骤自行注销：<br>
          （1）打开中人web端，登录需要注销的中人工业互联网账号<br>
          （2）点击底部导航"我的"<br>
          （3）点击右上角"设置图标"<br>
          （4）点击"账号与安全"<br>
          （5）选择"注销账号"<br>
          （6）点击"确认注销"
        </p>
        <p class="MsoNormal">
          <strong>三、本产品服务内容</strong><br>
          1、您可能可以通过电脑、手机等终端以网页、客户端等形式使用本产品，具体以本公司提供的为准，同时，本公司会不断丰富您使用本软件的终端、形式等。当您使用本产品时，您应选择与您的终端、系统等相匹配的本产品版本，否则，您可能无法正常使用本产品。<br>
          2、本产品为您提供的服务<br>
          （1）应用商店：本服务为用户提供多种类型的数字化应用，游客用户可以在本服务中直接向应用发起产品咨询。<br>
          （2）解决方案：本服务（仅在中人工业互联网平台）面向企业用户，即您如果需要使用本项服务，应进行注册并企业认证。为企业用户提供多种行业、领域的解决方案。<br>
          （3）供需大厅：本服务可以面向企业用户、也可以面向自然人用户，本服务提供企业需求，用户可以对需求进行留言回复。<br>
          （4）企业诊断：本服务（仅在中人工业互联网平台）面向企业用户，即您如果需要使用本项服务，应进行注册并企业认证，本服务为企业用户提供企业多场景问题诊断和解决方案。<br>
          （5）中人数字金融：本服务面向企业用户，即您如果需要使用本项服务，应进行注册并企业及企业法人实名认证。本服务基于中人工业互联网平台，依托政府、金融机构和企业经营动态大数据，运用人工智能、云计算、区块链和物联网等先进技术，坚持市场化导向，充分发挥资金的驱动作用和社会化风险分担机制的缓释作用，重构信用体系，确立数字信任，引导金融活水精准滴灌实体经济。<br>
          （6）开发者社区：本服务可以面向企业用户、也可以面向自然人用户。<br>
          （7）用户同意，本公司保留新增服务，变更、中止或终止提供以上服务的权利。
        </p>
        <p class="MsoNormal">
          3、服务费用<br>
          （1）本产品的某些服务是以收费方式提供的，如您使用收费服务，请遵守服务相关的协议。若您不同意相关协议及其修改和变更，请暂停使用相关增值服务并可通过该页面底部提供的联系方式联系本公司。<br>
          （2）本公司有权决定收费类服务的收费标准，具体的收费标准以本产品相关收费服务页面公布的标准为准，用户可以根据需要自行选择并付费使用相应服务。<br>
          （3）您理解并同意，您支付前述费用的方式将通过我们接入的第三方支付工具（如微信支付、支付宝等）向我们进行付款。支付功能本身并不收集您的个人信息，但我们需要将您的订单信息与交易金额信息与这些支付机构共享以实现确认您的支付指令并完成支付。我们善意提醒您，在与第三方支付建立法律关系前，您应审慎阅读第三方支付的用户服务协议、隐私政策等法律文件。<br>
          （4）您理解并同意，若您已经根据本产品中公布的费用标准完成了付款，除因您购买的相应收费类服务出现侵权纠纷原因导致您无法正常使用该服务外，我们不会退还您为使用该服务而支付的款项，且本公司无须承担任何责任。<br>
          （5）若您在购买服务时有任何问题或疑问，您可以添加各服务页面提供的客服联系方式进行咨询，或通过该页面底部提供的联系方式联系我们。
        </p>
        <p class="MsoNormal">
          <strong>四、用户使用规范</strong><br>
          1、本公司授权您非商业性使用本产品，但是如果要进行商业性使用（包括但不限于：销售、复制、散发、预装、捆绑或用于其他商业活动）时，必须事先获得本公司的书面授权和许可。<br>
          2、您可以就本产品的下载、安装、使用或卸载问题向本公司提出咨询，本公司解答的义务不应超过本公司的合理承受限度。如果您对本产品有任何意见，或有如何改进的建议，请使用"意见反馈"功能发表您的意见或建议。<br>
          3、 用户充分了解并同意，您在本产品上发布、上传、分享、传播的科技成果、应用、解决方案，或作为专家为其他用户提供的专业咨询答复意见均为您个人的意见及建议，均不代表本公司的观点，本公司对此不承担任何责任。<br>
          4、 用户应对本产品的其他用户、本产品专家资源的专家、本产品链接的第三方平台提供的内容自行加以判断，并承担因使用该内容而引起的所有风险，包括因对内容的正确性、完整性或合法性的依赖而产生的风险，本产品对此不承担任何法律责任。<br>
          5、您不得修改、复制、传播与本产品相关的材料，如果您复制和修改传播这些材料，因此而造成对其他人的损害，或者造成对本公司的形象损害，要承担相应的法律责任。 您不得删除、掩盖或更改本公司的版权声明、商标或其它权利声明。<br>
          6、 用户在本产品上传、发布、传播的科技成果、应用、解决方案，或作为专家为其他用户提供的专业咨询答复意见均为您个人的意见及建议，均应保证不违反法律法规及其规范性文件，亦不侵犯任何第三方的合法权益，并同意本公司有权将用户在本产品上发布、上传、分享、传播的信息在全世界范围内，永久性的、不可撤销的、免费的使用、复制、传播。否则导致的一切不利后果均由用户自行承担，造成本公司损失的，还应向本公司承担赔偿责任。对于相关权利人因用户违反本款约定向本公司主张权利的，本公司有权不通知上传用户直接删除、下线、屏蔽相关争议内容。<br>
          7、用户应当保证，不会利用本产品侵犯本公司以及他人的合法权益，禁止通过网络漏洞、恶意软件或其他非法手段破坏本产品的正常经营。否则，本公司有权根据情节严重而对该用户及用户账号进行冻结、封号等处理。构成犯罪的，本公司有权移交司法部门处理。<br>
          8、禁止用户从事以下行为：<br>
          （1）使用未经公司授权或许可的任何插件、外挂、系统或第三方工具对本产品的正常运行进行干扰、破坏、修改或施加其他影响。<br>
          （2）利用或针对本产品进行任何危害计算机网络安全的行为，包括但不限于：<br>
          1）非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；<br>
          2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；<br>
          3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；<br>
          4）使用未经许可的数据或进入未经许可的服务器/账号；<br>
          5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；<br>
          6）未经许可，企图探查、扫描、测试本服务系统或网络的弱点或其它实施破坏网络安全的行为；<br>
          7）企图干涉、破坏本服务系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；<br>
          8）伪造TCP/IP数据包名称或部分名称。<br>
          （3）对本产品进行反向工程、反向汇编、编译或者以其他方式尝试发现本产品的源代码。<br>
          （4）恶意注册本产品账号，包括但不限于频繁、批量注册账号。<br>
          （5）不得制作、复制、上传、发布、传播法律、行政法规禁止的下列信息内容：<br>
          1）反对宪法确定的基本原则的；<br>
          2）危害国家安全，泄露国家秘密的；<br>
          3）颠覆国家政权，推翻社会主义制度、煽动分裂国家、破坏国家统一的；<br>
          4）损害国家荣誉和利益的；<br>
          5）宣扬恐怖主义、极端主义的；<br>
          6）宣扬民族仇恨、民族歧视，破坏民族团结的；<br>
          7）煽动地域歧视、地域仇恨的；<br>
          8）破坏国家宗教政策，宣扬邪教和迷信的；<br>
          9）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；<br>
          10）散布、传播暴力、淫秽、色情、赌博、凶杀、恐怖或者教唆犯罪的；<br>
          11）侵害未成年人合法权益或者损害未成年人身心健康的；<br>
          12）未获他人允许，偷拍、偷录他人，侵害他人合法权利的；<br>
          13）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的；<br>
          14）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；<br>
          15）侮辱或者诽谤他人，侵害他人合法权益的；<br>
          16）对他人进行暴力恐吓、威胁，实施人肉搜索的；<br>
          17）涉及他人隐私、个人信息或资料的；<br>
          18）散布污言秽语，损害社会公序良俗的；<br>
          19）侵犯他人隐私权、名誉权、肖像权、知识产权、商业秘密等合法权益内容的；<br>
          20）未经公司许可，利用本产品为自己或第三方进行推广、发布广告的（包括但不限于加入第三方链接、广告等行为）；<br>
          21）过度营销信息，骚扰信息和/或垃圾信息、低俗类信息、垃圾广告的；<br>
          22）使用本产品常用语言文字以外的其他语言文字制作、复制、上传、发布、传播的内容、留言、评论的；<br>
          23）与所制作、复制、上传、发布、传播的内容、留言、评论的信息毫无关系的；<br>
          24）所发布、传播的内容毫无意义的，或刻意使用字符组合以逃避技术审核的；<br>
          25）其他违反法律法规、政策及公序良俗、干扰本产品合作平台正常运营或侵犯其他用户或第三方合法权益内容的其他信息。
        </p>
        <p class="MsoNormal">
          <strong>五、权利声明及保密</strong><br>
          1、本公司拥有本产品的知识产权等相关权利，受国际版权公约、中华人民共和国著作权法、专利法及其他知识产权方面的法律法规的保护。<br>
          2、本公司授予您对本产品的可撤销的、有限的、非排他的、不可转让的使用权，您仅限于以非商业使用本公司为目的进行使用。<br>
          3、保密<br>
          （1）本公司将采取特殊保密措施，维护本服务的安全与正常使用是本公司和您的共同责任，本公司将采取适当的安全措施和技术手段维护本产品。<br>
          （2）您理解并同意，若非因本公司人为原因，如因天灾、盗窃、抢劫、黑客攻击等造成信息泄露的，本公司不承担法律责任。<br>
          （3）本公司在下述情况下不再承担保密义务：<br>
          1）因非本公司的原因，您提供的信息、语音、视频及文字稿件被公开的；<br>
          2）法律法规要求、行政司法机关要求、或其他有权机关要求披露的；<br>
          3）事先获得您的授权；<br>
          4）为查找、预防或处理欺诈、安全或技术方面的问题；<br>
          5）为执行相关服务协议或本政策、维护社会公共利益；<br>
          6）为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益等合理且必要的用途。
        </p>
        <p class="MsoNormal">
          <strong>六、无担保声明</strong><br>
          1、虽然本产品（包括其升级版）经过本公司详细的测试，但本公司不能保证其与所有的软硬件、系统完全兼容。如果出现不兼容的情况您可将情况通知我们，以获得技术支持。如果无法解决问题，您可以选择停止使用本产品。<br>
          2、本公司对以下事宜不作任何类型的担保，不论是明确的或隐含的：<br>
          （1）本协议项下本产品提供的相关网络服务将符合用户的要求；<br>
          （2）本协议项下本产品提供的相关服务将不受不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、电信部门原因及其他任何网络、技术、通信线路等外界或人为因素的影响；<br>
          3、第三方产品和服务<br>
          （1）您知悉并同意，若您在使用通过本产品的链接和标签所指向的第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议，您使用第三方提供的产品或服务可能出现的纠纷由您自行解决并承担风险。<br>
          （2）因您使用本软件或要求本产品提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持您的使用或访问，使用或访问的结果由该第三方提供（包括但不限于第三方通过本软件插件提供的服务），本公司不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害由您自行承担。<br>
          （3）前述通过各种形式展现的相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求本公司给予协助，您应当自行承担法律责任。
        </p>
        <p class="MsoNormal">
          <strong>七、隐私保护</strong><br>
          隐私保护相关条款以《隐私政策》内容为准
        </p>
        <p class="MsoNormal">
          <strong>八、违约处理</strong><br>
          1、针对您违反本协议或其他服务条款的行为，本公司有权独立判断并视情况采取预先警示、拒绝发布、要求整改、立即停止提供服务、删除内容、暂停更新、限制账号部分或者全部功能直至永久关闭账号等措施。 本公司有权公告处理结果，且有权根据实际情况决定是否恢复使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。<br>
          2、因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行承担全部法律责任。因您的违法或违约行为导致本公司及其关联公司、控制公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿本公司及其关联公司、控制公司因此遭受的全部损失。<br>
          3、本公司尊重并保护法人、公民的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用本产品时上传的文字、图片、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，本公司有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行承担全部法律责任；如因您的侵权行为导致本公司及其关联公司、控制公司遭受损失的（包括经济、商誉等损失），您还应足额赔偿本公司及其关联公司、控制公司遭受的全部损失。
        </p>
        <p class="MsoNormal">
          <strong>九、服务的变更、中断和终止</strong><br>
          1、您理解并同意，本公司提供的本产品及相关服务是按照现有技术和条件所能达到的现状提供的。本公司会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，本公司不能随时预见和防范技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵及其他各种安全问题的侵扰等原因可能导致的服务中断、数据丢失以及其他的损失和风险。<br>
          2、您理解并同意，本公司为了服务整体运营的需要，有权在公告通知后修改、中断、中止或终止本产品的服务，而无须向您负责或承担任何赔偿责任。<br>
          3、本公司有权提前30天通知您解除本协议，该情况下，本公司解除本协议时您的账户内仍有已支付且未完成订单的，本公司将以该订单的实付金额为限向您提供适当补偿。<br>
          4、如发生下列任何一种情形，本公司有权随时中断或终止向您提供本协议项下的网络服务而无需通知您：<br>
          （1）您提供的注册、认证等资料不真实；<br>
          （2）您违反本协议即本产品的其他规则的；<br>
          （3）您认证的企业发生被吊销、撤销营业执照等情形，不再具有主体资质的；<br>
          （4）您认证的企业存在重大经营风险的。
        </p>
        <p class="MsoNormal">
          <strong>十、通知和送达</strong><br>
          1、您在使用本产品过程中有任何意见或建议，可通过本产品内 【意见反馈】 提出，我们将向您及时做出反馈。您应保证您的联系方式畅通，以接收来自我们发出的电话或信息，我们不对您未收到通知而引起的任何损失承担责任。<br>
          2、如您在使用本产品的过程中对本用户服务协议有任何疑问或建议，请通过以下联系方式与我们联系:<br>
          电子邮件: ceo@zrgyhl.com<br>
          电 话: 400-166-1106<br>
          联系微信公众号："中人工业互联网"（打开微信-添加好友-公众号-搜索"中人工业互联网"）<br>
          联系地址：江苏省苏州市工业园区金鸡湖大道88号人工智能产业园G1-501单元<br>
          为保障我们高效处理您的问题并及时向您反馈，需要您提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。一般情况下，我们将在三十天内回复。<br>
          3、本公司将采取公告、系统消息、站内信、向您提供的联系地址发送信息等方式中的任一种向您送达本产品上的各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。<br>
          4、本公司采取电子方式发送的，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。<br>
          5、对于在本产品上因各类活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在本产品注册、认证、更新时提供的手机号码、电子邮箱等联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。<br>
          6、你应当保证注册时所提供的联系方式是准确、有效的，并进行实时更新。如果因您提供的联系方式不准确，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
        </p>
        <p class="MsoNormal">
          <strong>十一、其他</strong><br>
          1、本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向本公司所在地的人民法院提起诉讼。<br>
          2、本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。<br>
          3、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br>
          4、本服务仅限于在中国大陆地区使用，如您擅自在中国大陆以外地区使用，公司不承担因此而产生的任何责任。<br>
          5、本协议自用户同意勾选或网上签署并成功注册成为本产品用户之日起生效，除非本公司终止本协议或者用户丧失本产品用户资格，否则本协议始终有效。本协议终止并不免除用户根据本协议或其他有关协议、规则所应承担的义务和责任。
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  login, wxLogin, loginout,
  getInfo,
  getThirdPartyAuthUrl, completeThirdPartyUserInfo
} from "../api/userMG";
import { sendSms ,phoneLogin} from "../api/userMG";
import { official_web_url } from "../api/baseUrl";
export default {
  name: "login",
  components: {
  },
  data() {
    return {
      appid: '',
      official_web_url: official_web_url,
      callBack: "",
      openid: "",
      countdown: 0, // 倒计时的秒数
      timer: null, // 计时器
      toggleState: true,
      checked: true,
      logining: false,
      smsCodeState: true,
      rememberpwd: false,
      ruleForm: {
        userPhone: "",
        userPassword: "",
        loginIp: "",
        loginSource: '0',
        codeimg: "",
        randomStr: '',
        smsCode: '',
        code: '',
        companyId: '',
        companyName: '',
        phone: ''
      },
      client_id:'zr_platform',
      redirect_uri:'',
      redirect:'',
      privacyDialogVisible: false, // 添加隐私政策对话框显示状态
      loginTab: 'sms', // 新增，默认短信登录
      currentPlatform: '',
      thirdPartyId: '',
      passwordVisible: false,
      formError: '',
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 检查是否已登录
    const token = localStorage.getItem("logintoken");
    if (token) {
      // 如果已登录，根据redirect参数或默认跳转到个人中心
      if (this.redirect) {
        window.location.href = decodeURIComponent(this.redirect);
      } else {
        this.$router.push("/auth/userHome");
      }
      return;
    }

    // 处理从忘记密码页面跳转过来的参数
    if (this.$route.query.loginTab === 'password') {
      this.loginTab = 'password';
      if (this.$route.query.phone) {
        this.ruleForm.userPhone = this.$route.query.phone;
      }
    }

    if (window.location.href.indexOf('client_id=') > -1) {
      this.client_id = window.location.href.split("client_id=")[1];
      this.client_id=this.client_id.split('&')[0];
      this.redirect_uri = window.location.href.split("redirect_uri=")[1];
      this.redirect_uri=this.redirect_uri.split('&')[0];
    }
    if (window.location.href.indexOf('redirect=') > -1) {
      this.redirect = window.location.href.split("redirect=")[1];
    }
    if (window.location.href.indexOf('platform=gitee') > -1 || window.location.href.indexOf('platform=wechat_open') > -1) { // 第三方登录
      let searchUrl = window.location.href.split('?')[1];
      this.$router.push('/auth/callback?'+searchUrl)
    }
  },
  methods: {
    logout() {
      loginout().then((res) => {
        localStorage.clear();
        localStorage.removeItem("userdata");
        localStorage.removeItem("userAccount");
        localStorage.removeItem("biaoshi");
        localStorage.removeItem("supplierInfo");
        localStorage.removeItem('sysRolePower')
        this.$store.commit("logout", "false");
        this.name = "";
      });

    },
    toPath(){
      window.location.href =this.official_web_url;
    },
    getInfo() {
      // 先清除旧的菜单权限数据
      localStorage.removeItem('userMenuPermissions');
      localStorage.removeItem('userMenuIds');

      // 请求用户信息
      getInfo().then((res) => {
        if (res.code == 200) {
          console.log('获取用户信息成功:', res.data);

          // 保存用户信息
          localStorage.setItem("userdata", JSON.stringify(res.data.user));
          localStorage.setItem("company", JSON.stringify(res.data.company));

          // 保存角色权限
          if (res.data.sysRolePower != null && res.data.sysRolePower.length > 0) {
            localStorage.setItem("sysRolePower", JSON.stringify(res.data.sysRolePower));
          } else {
            localStorage.removeItem('sysRolePower');
          }

          // 保存菜单权限ID列表
          if (res.data.userMenuIds != null && res.data.userMenuIds.length > 0) {
            console.log('后端返回的菜单ID列表:', res.data.userMenuIds);
            localStorage.setItem("userMenuIds", JSON.stringify(res.data.userMenuIds));
          } else {
            console.warn('后端未返回菜单ID列表');
            localStorage.removeItem('userMenuIds');
          }

          // 保存供应商信息
          if (res.data.supplierInfo != null) {
            localStorage.setItem("supplierInfo", JSON.stringify(res.data.supplierInfo));
          } else {
            localStorage.removeItem('supplierInfo');
          }

          // 处理登录后的跳转逻辑
          setTimeout(() => {
            if (this.redirect == '') {
              if (this.redirect_uri == '') {
                this.jumpUrlFn();
              }
            } else {
              window.location.href = decodeURIComponent(this.redirect) + '?username=' + res.data.user.userPhone;
            }
          }, 100);
        } else {
          this.$message.error("获取用户信息失败，请重新登录");
          localStorage.removeItem("logintoken");
        }
      }).catch(err => {
        console.error('获取用户信息失败:', err);
        this.$message.error("获取用户信息失败，请重新登录");
        localStorage.removeItem("logintoken");
      });
    },
    sendSms() {
      if (!this.checked) {
        this.loading = false;
        this.$message.error("请查看并阅读《用户隐私协议》后勾选");
        return false;
      }
      if (!this.ruleForm.userPhone || !this.ruleForm.userPhone.trim()) {
        this.$message.error("请输入手机号");
        return false;
      }
      if (!this.isValidPhone(this.ruleForm.userPhone)) {
        this.$message.error("您输入手机号不正确，请重新输入");
        return false;
      }
      const formData = new FormData();
      formData.append("phone", this.ruleForm.userPhone);
      sendSms(formData)
        .then((res) => {
          if (res.data.code === 200) {
            setTimeout(() => {
              this.$message({ type: "success", message: "验证码已发送，2分钟内有效!" });
              // 开始倒计时
              this.countdown = 120;
              this.timer = setInterval(() => {
                if (this.countdown > 0) {
                  this.countdown -= 1;
                } else {
                  clearInterval(this.timer);
                }
              }, 1000);
            }, 100);
          } else {
            this.$message.error(res.data.message || "发送验证码失败");
          }
        }).catch((err) => {
          this.$message.error("请勿频繁发送验证码，请稍后再试");
        });
    },
    isValidPhone(phone) {
      return /^1[3-9]\d{9}$/.test(phone);
    },
    jumpUrlFn() {
      this.$router.push({ path: "/auth/userHome" });
    },
    wxLogin(code) {
      wxLogin(code).then(res => {
        if (res.code == '200') {
          this.openid = res.data.user.wxOpenid
          this.iphoneForm.userId = res.data.user.userId
          //跳转页面的逻辑
          this.logining = false;
          // 缓存token
          localStorage.setItem("logintoken", res.data.token);
          localStorage.setItem("userdata", JSON.stringify(res.data.user));
          localStorage.setItem("company", JSON.stringify(res.data.company));
          // 缓存用户个人信息
          this.$store.commit("login", "true");

          if (!res.data.user.userPhone) {
            //弹窗 让用户绑定手机号
            this.formDialog1 = true

          } else {
            this.getInfo();
          }
        }
        console.log(res, 'loginres');

      })
    },
    phoneLogin(){
      let params = {
        phone:this.ruleForm.userPhone,
        smsCode:this.ruleForm.smsCode ,
        client_id:this.client_id,
        redirect_uri:this.redirect_uri
      }
      this.logining = true;

      phoneLogin(params)
        .then((res) => {
         
          if(this.redirect_uri!=''){
            window.location.href =res.request.responseURL;
          } else {
           
            if (res.code == 200) {
              // 登录成功，存储token信息
              localStorage.setItem("logintoken", res.data.accessToken);
              localStorage.setItem("refreshToken", res.data.refreshToken);
              this.$store.commit("login", "true");
              
              this.$message({ type: "success", message: "登录成功" });
              this.getInfo();
            } else {
              this.logining = false;
              this.$message.error(res.data.message || "登录失败");
            }
          }
        }).catch((err) => {
          this.logining = false;
          this.$message.error(
            (err.response && err.response.data && err.response.data.message) || "登录失败，请重试"
          );
        });
    },

    //获取info列表
    submitForm() {
      if (!this.checked) {
        this.loading = false;
        this.$message.error("请查看并阅读《用户隐私协议》后勾选");
        return false;
      }
      if (this.ruleForm.userPhone == "" || !this.ruleForm.userPhone.trim()) {
        this.loading = false;
        this.$message.error("请输入手机号");
        return false;
      } else {
        if (this.ruleForm.smsCode == "" ||
          this.ruleForm.smsCode == null) {
          this.$message.error('请输入短信验证码')
          this.logining = false
          return false
        } else {
          this.logining = true;
          this.phoneLogin();
        }
      }
    },
    // 处理第三方登录
    async handleThirdPartyLogin(platform) {
      try {
        const res = await getThirdPartyAuthUrl(platform);
        // res 直接就是 URL 字符串
        if (res) {
          // 直接跳转到授权页面
          window.location.href = res;
        } else {
          this.$message.error('获取授权地址失败');
        }
      } catch (error) {
        console.error('Third party auth error:', error);
        this.$message.error('获取授权地址失败');
      }
    },

    // 处理第三方登录回调
    handleAuthCallback(event) {
      // 移除事件监听
      window.removeEventListener('message', this.handleAuthCallback);

      const { data } = event;
      if (data.type === 'thirdPartyAuth') {
        if (data.hasUser) {
          // 已有关联用户，直接登录
          localStorage.setItem("logintoken", data.tokenResponse.accessToken);
          localStorage.setItem("refreshToken", data.tokenResponse.refreshToken);
          this.$store.commit("login", "true");
          this.$message({ type: "success", message: "登录成功！" });
          this.getInfo();
        } else {
          // 需要补充用户信息
          this.currentPlatform = data.platform;
          this.thirdPartyId = data.thirdPartyId;
          this.showCompleteUserInfo();
        }
      }
    },

    // 显示补充用户信息弹窗
    showCompleteUserInfo() {
      this.$prompt('请输入用户名', '完善信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\w\u4e00-\u9fa5]{3,20}$/,
        inputErrorMessage: '用户名格式不正确（支持3-20位中文、字母、数字、下划线）'
      }).then(({ value: userName }) => {
        this.$prompt('请输入手机号', '完善信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^1[3-9]\d{9}$/,
          inputErrorMessage: '请输入正确的手机号'
        }).then(({ value: userPhone }) => {
          this.$prompt('请设置密码', '完善信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            inputPattern: /^.{6,20}$/,
            inputErrorMessage: '密码长度需在6-20位之间'
          }).then(({ value: userPassword }) => {
            this.submitCompleteInfo({
              userName,
              userPhone,
              userPassword
            });
          });
        });
      });
    },

    // 提交补充的用户信息
    async submitCompleteInfo(data) {
      try {
        const res = await completeThirdPartyUserInfo(
          this.currentPlatform,
          this.thirdPartyId,
          data
        );

        if (res.code === 200) {
          localStorage.setItem("logintoken", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          this.$store.commit("login", "true");
          this.$message({ type: "success", message: "注册成功！" });
          this.getInfo();
        } else {
          this.$message.error(res.msg || '注册失败');
        }
      } catch (error) {
        console.error('Complete user info error:', error);
        this.$message.error('注册失败，请重试');
      }
    },

    // 加载用户菜单权限
    loadUserMenuPermissions(userId, userRoles) {
      console.log('开始加载用户菜单权限, 用户ID:', userId);

      // 提取用户角色ID
      const roleIds = userRoles.map(role => role.roleId);
      console.log('用户角色列表:', roleIds);

      // 如果用户没有角色，直接返回
      if (!roleIds || roleIds.length === 0) {
        console.warn('用户没有分配角色，无法获取菜单权限');
        localStorage.setItem('userMenuPermissions', JSON.stringify([]));
        return;
      }

      // 获取每个角色的菜单权限
      const promises = roleIds.map(roleId => {
        return this.loadRoleMenuPermissions(roleId);
      });

      // 等待所有Promise完成
      Promise.all(promises).then(results => {
        // 合并所有角色的菜单权限
        let allMenuIds = [];
        results.forEach(menuIds => {
          if (menuIds && menuIds.length > 0) {
            allMenuIds = [...new Set([...allMenuIds, ...menuIds])];
          }
        });

        // 保存菜单权限到localStorage
        localStorage.setItem('userMenuPermissions', JSON.stringify(allMenuIds));
        console.log('用户菜单权限已加载完成:', allMenuIds);

        // 触发菜单更新事件
        window.dispatchEvent(new CustomEvent('menu-permissions-updated'));
      });
    },

    // 加载角色的菜单权限
    loadRoleMenuPermissions(roleId) {
      console.log(`开始获取角色[${roleId}]的菜单权限`);

      return new Promise((resolve, reject) => {
        // 带上时间戳参数防止浏览器缓存
        const timestamp = new Date().getTime();
        this.$axios.get(`/zr-admin/systemMenu/roleMenuTreeselect/${roleId}?_t=${timestamp}`, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('logintoken'),
            'X-Client-Id': 'zr_platform',
            'X-User-Id': this.$store.state.user || ''
          }
        })
        .then(response => {
          if (response.data && response.data.code === 200) {
            console.log(`角色[${roleId}]菜单权限获取成功:`, response.data.data);
            resolve(response.data.data || []);
          } else {
            console.warn(`获取角色[${roleId}]菜单权限失败:`, response.data ? response.data.msg : '未知错误');
            resolve([]);
          }
        })
        .catch(error => {
          console.error(`获取角色[${roleId}]菜单权限发生错误:`, error);
          resolve([]);
        });
      });
    },
    // 显示隐私政策对话框
    showPrivacyDialog() {
      this.privacyDialogVisible = true;
    },
    // 处理隐私政策对话框关闭
    handlePrivacyDialogClose(done) {
      this.privacyDialogVisible = false;
    },
    // 密码登录校验规则
    isValidPhone(phone) {
      return /^1[3-9]\d{9}$/.test(phone);
    },
    isValidPassword(pwd) {
      return /^[A-Za-z][A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{7,19}$/.test(pwd)
        && /[A-Za-z]/.test(pwd)
        && /\d/.test(pwd)
        && /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd);
    },
    // 密码登录提交
    submitPasswordLogin() {
      this.formError = '';
      if (!this.checked) {
        this.formError = "请查看并阅读《用户隐私协议》后勾选";
        return;
      }
      if (!this.ruleForm.userPhone || !this.ruleForm.userPhone.trim()) {
        this.formError = "请输入手机号";
        return;
      }
      if (!this.ruleForm.userPassword || !this.ruleForm.userPassword.trim()) {
        this.formError = "请输入密码";
        return;
      }
      if (!this.isValidPhone(this.ruleForm.userPhone)) {
        this.formError = "您输入手机号不正确，请重新输入";
        return;
      }
      if (!this.isValidPassword(this.ruleForm.userPassword)) {
        this.formError = "密码必须包含数字、字母和特殊符号，第1位字母开头";
        return;
      }
      this.logining = true;
      // 假设loginAndRegister支持密码登录，实际接口参数如有不同请调整
      login({
        username: this.ruleForm.userPhone,
        password: this.ruleForm.userPassword,
        client_id: this.client_id,
        redirect_uri:this.redirect_uri
      }).then(res => {
        this.logining = false;
        if (res.code === 200) {
          // 根据新的返回数据格式存储token
          localStorage.setItem("logintoken", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          res.data.user?  localStorage.setItem("userdata", JSON.stringify(res.data.user)):null;
          res.data.company?localStorage.setItem("company", JSON.stringify(res.data.company)):null;
          this.$store.commit("login", "true");
          this.$message({ type: "success", message: "登录成功！" });
          this.getInfo();
        } else {
          this.$message.error(res.message || "登录失败");
        }
      }).catch(() => {
        this.logining = false;
        this.$message.error("手机号或密码错误，请重新登录或找回密码！");
      });
    },
    switchLoginTab(tab) {
      this.loginTab = tab;
    },
  },
};
</script>
<style scoped>
.el-input {
  background-color: #fff;
}

::v-deep.el-input--prefix .el-input__inner {
  color: #000000;
  padding-left: 0;
}

.el-input-yzm {
  width: 342px !important;
}

.el-input-iphone {
  width: 342px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}


.login-container {
  background-image: url(../assets\images\bg\logo2.jpg);
  background-size: cover;
  background-position: 50%;
}

.login-container .index-login-section[data-v-37dfd6fc] {
  max-width: 1200px;
  width: 960px;
  height: 546px;
}

.login-container .login-form[data-v-37dfd6fc] {
  width: 480px;
  background-color: #fff;
  position: relative;
  height: 100%;
}

.login-container .index-login-section .img-logo[data-v-37dfd6fc] {
  padding-top: 48px;
  padding-bottom: 30px;
}

.login-container>img {
  margin-right: 0px;
  position: relative;
  top: 30px;
  max-width: 180px;
  left:7.2%;
  z-index:10;
}

.login-container .login-form .username[data-v-37dfd6fc] {
  margin-top: 30px;
}

.login-container .el-form-item {
  height: 39px;
  width: 343px;
  margin: 20px auto;
}

.el-form-item--medium .el-form-item__content,
.el-form-item--medium .el-form-item__label {
  line-height: 36px;
}

.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}

:global{
 
  .el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
  flex-direction: row !important;
}
}

.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}

.login-container .index-login-section .login-bottom-submit[data-v-37dfd6fc] {
  width: 343px;
  height: 39px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 30px auto 20px auto;
  background: -webkit-gradient(linear,
      left top,
      right top,
      from(#50e3c2),
      to(#025c5e));
  background: linear-gradient(90deg, #50e3c2 0%, #025c5e 100%);
  -webkit-box-shadow: 0px 2px 8px 0px rgba(80, 227, 194, 0.5);
  box-shadow: 0px 2px 8px 0px rgba(80, 227, 194, 0.5);
}

.login-bottom-submit {
  width: 343px;
  height: 39px;
  display: flex;
  justify-content: center;
  margin: 22px auto 20px auto;
  background: linear-gradient(90deg,
      rgba(80, 227, 194, 1) 0%,
      rgba(2, 92, 94, 1) 100%);
  box-shadow: 0px 2px 8px 0px rgba(80, 227, 194, 0.5);
}

.el-button--primary {
  color: #fff;
  border-radius: 0;
}

/* .login-container .login-form[data-v-37dfd6fc]:after {
  content: '';
  position: absolute;
  top: 0;
  width: 100px;
  bottom: 0;
  right: -100px;
  background: #fff;
  -webkit-clip-path: polygon(0 0, 100% 50%, 0 100%, 0 100%);
  clip-path: polygon(0 0, 100% 50%, 0 100%, 0 100%);
} */

.index-footer[data-v-37dfd6fc] {
  position: absolute;
  bottom: 20px;
  width: 100%;
}

.index-footer .index-footer-wrap[data-v-37dfd6fc] {
  max-width: 1200px;
  margin: 0 auto;
}

.index-footer .index-footer-wrap .index-footer-wrapbottom[data-v-37dfd6fc] {
  text-align: center;
  color: rgba(216, 216, 216, 0.5);
  font-size: 16px;
  line-height: 22px;
}

.sjh {
  color: black;
}

.yzmBox {
  margin-right: 60px;
  margin-left: 55px;
  text-align: center;

}

.activeBorder {
  background-color: orange;
  height: 4px;
}

.qrcodeBox {
  width: 163px;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  margin-right: 34px;
  text-align: center;
  margin-left: 10px;
}

.qrbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.warningBox {
  display: flex;
  align-items: center;
  width: 521px;
  height: 50px;
  border: 1px solid #ffe799;
  background-color: #fffbe6;
  margin: 0 auto;
  padding-left: 20px;
  margin-bottom: 30px;
}

/* 添加第三方登录相关样式 */
.third-party-login {
  margin: 20px 0;
  text-align: center;

  .divider {
    position: relative;
    text-align: center;
    margin-bottom: 20px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 45%;
      height: 1px;
      background-color: #dcdfe6;
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }

    span {
      background-color: #fff;
      padding: 0 10px;
      color: #909399;
      font-size: 14px;
    }
  }

  .third-party-icons {
    display: flex;
    justify-content: center;

    .icon-item {
      cursor: pointer;
      transition: opacity 0.3s;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.icon-item img{
      position:static;
      width:30px;
}
.privacy-dialog {
  /* 移除flex相关样式，仅保留内容样式 */
  .privacy-content {
    max-height: 70vh;
    overflow-y: auto;
    padding: 20px;
  }
  .MsoNormal {
    margin: 10px 0;
    line-height: 1.6;
  }
}
:deep(.el-dialog) {
  margin: 0 auto !important;
}

:global{
  .el-input__prefix{
    font-size: 16px;
    top: 10px;
    left: 7px;
  }
  .el-input__suffix {
    display: flex;
    align-items: center;
  }
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
  }
  .el-icon-view {
    font-size: 16px;
    line-height: 1;
  }
}

.form-error-message {
  color: #f56c6c;
  font-size: 14px;
  line-height: 1;
  margin: -10px 0 10px 0;
  display: flex;
  align-items: center;
  padding: 0 68px;
}

.form-error-message i {
  margin-right: 5px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue